import { Box, Button } from "@chakra-ui/react";

import { useCanReinvest, useUserInvestments } from "@/hooks/useInvestments";
import { Text } from "@equidefi/ui";
import { useNavigate } from "react-router";

export const ReinvestBox = ({ offering }) => {
  const navigate = useNavigate();

  const { data: investments } = useUserInvestments({ offering_id: offering.id }, { refetchOnMount: "always" });

  const canReinvest = useCanReinvest(investments);

  if (!canReinvest) {
    return null;
  }

  return (
    <Box borderRadius="lg" mt={4} p={4} bgColor="#cba3ff33" borderColor="accent" borderWidth="2px">
      <Text my="0" mb="0" fontSize="xs" textTransform="uppercase">
        Invest Again
      </Text>
      <Text as="h3" mb="0" fontWeight="bold" fontSize="lg">
        Want to Invest Again?
      </Text>
      <Text mb="2" textStyle="body">
        You can start a new investment in under 10 minutes!
      </Text>
      <Button
        w="full"
        onClick={() => {
          navigate(`/offerings/${offering.slug}/reinvest`);
        }}>
        Invest Again
      </Button>
    </Box>
  );
};
